<template>
  <svg width="24px" height="31px" viewBox="0 0 24 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-327.000000, -458.000000)" fill="#FFFFFF" fill-rule="nonzero">
        <g transform="translate(-3.000000, 330.554113)">
          <g transform="translate(330.941619, 128.337966)">
            <path d="M11.5213094,0 C7.09280609,0 3.45639282,3.64924958 3.45639282,8.09338521 L3.45639282,11.5619789 L0,11.5619789 L0,30.0611451 L23.0426188,30.0611451 L23.0426188,11.5619789 L19.586226,11.5619789 L19.586226,8.09338521 C19.586226,3.64924958 15.9498127,0 11.5213094,0 Z M11.5213094,2.31239578 C14.6941697,2.31239578 17.2819641,4.90932491 17.2819641,8.09338521 L17.2819641,11.5619789 L5.76065469,11.5619789 L5.76065469,8.09338521 C5.76065469,4.90932491 8.34844908,2.31239578 11.5213094,2.31239578 Z M2.30426188,13.8743747 L20.7383569,13.8743747 L20.7383569,27.7487493 L2.30426188,27.7487493 L2.30426188,13.8743747 Z" id="Shape"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
